export default (data) => {
  const { cardActivityType, activityId, planCode, channelId, resourceId, umActivityId, roomId, channelType } = data;
  switch (cardActivityType) {
    case 12:
      return `/activity-manage/merchants/venueDetail/poolList?entry=1&planCode=${planCode}&roomId=${roomId}&activityId=${activityId}&from=acore&hideTab=1`;
    case 13:
      return `/activity-manage/merchants/detail/promotion/myJoin/detail/activityEnroll/detail?activity_id=${umActivityId}&planCode=${planCode}&tab_key=2`;
    case 21:
      return channelType == 3
        ? `/platform-marketing/resource-detail/material-collection/distribute/roomlist?channelId=${channelId}&resourceId=${resourceId}&activityId=${activityId}&entry=1&hideTab=1&id=${activityId}`
        : `/channel-service/position/resource-detail/material-collection/distribute/roomlist?channelId=${channelId}&resourceId=${resourceId}&activityId=${activityId}&entry=1&hideTab=1&id=${activityId}`;
    case 22:
      return channelType == 3
        ? `/platform-marketing/${channelId}/cuxiao-play-and-detail/activityEnroll/detail?activity_id=${umActivityId}&tab_key=2`
        : `/channel-service/position/${channelId}/cuxiao-play-and-detail/activityEnroll/detail?activity_id=${umActivityId}&tab_key=2`;
    case 30:
      return `/ph/phActivityDetail/enroll/signUp?id=${activityId}`;
    case 31:
      return `/activity-manage/myCreate/pools/roomlist?entry=1&activityId=${activityId}&from=acore&hideTab=1&id=${activityId}`;
    case 32:
      return `/activity-manage/myCreate/zongcuActivity/myJoin/detail/activityEnroll/detail?activity_id=${umActivityId}`;
  }
};
